export class ImanagerInfoModel {
    id: string;
    name: string;
    depid: string;
    depname: string;
    auth_product: boolean;
    auth_discount: boolean;
    auth_push: boolean;
    auth_order: boolean;
    accessToken: string;
}

export class managerInfoModel implements ImanagerInfoModel {
    public id: string = "";
    public name: string= "";
    public depid: string= "";
    public depname: string= "";
    public auth_product: boolean = false;
    public auth_discount: boolean = false;
    public auth_push: boolean = false;
    public auth_order: boolean = false;
    public accessToken: string = "";

    public transTo(value: any): managerInfoModel
    {
        this.id = value.id;
        this.name = value.name;
        this.depid = value.depid;
        this.depname = value.depname;
        this.auth_product = value.auth_product;
        this.auth_discount = value.auth_discount;
        this.auth_push = value.auth_push;
        this.auth_order = value.auth_order;
        this.accessToken = value.accessToken;
        
        return this;
    }
}
